import React, { useEffect, useState } from "react";
import Component from "./news_slider";
import RsjcLogo from "../assets/RSJC_logo_jpg-02-02.jpg";
import eventsData from "../data/events.json"; // Ensure this path is correct

const IndexContent1 = () => {
  const [nearestEvent, setNearestEvent] = useState(null);

  useEffect(() => {
    console.log("Raw JSON Data:", eventsData);

    if (!eventsData?.events || !Array.isArray(eventsData.events)) {
      console.error("Invalid JSON format");
      return;
    }

    const today = new Date();

    const validEvents = eventsData.events
      .map((event) => {
        const dateObj = new Date(Date.parse(event.eventDate + " UTC")); // Ensure valid date parsing
        console.log(`Parsed Date for ${event.eventTitle}:`, dateObj);

        if (isNaN(dateObj)) {
          console.error("Invalid date format:", event.eventDate);
          return null;
        }

        return { ...event, dateObj };
      })
      .filter((event) => event && event.dateObj >= today) // Only future events
      .sort((a, b) => a.dateObj - b.dateObj);

    console.log("Filtered & Sorted Events:", validEvents);

    setNearestEvent(validEvents[0] || null);
  }, []);

  return (
    <div className="w-full bg-[#01184D] text-white content-center mx-auto">
      <div className="flex items-center justify-center">
        <Component />
      </div>
      <div className="mx-auto grid md:grid-cols-2 h-auto">
        <div className="justify-center bg-[#075AAA]">
          <img
            className="h-[400px] mx-auto"
            src={RsjcLogo}
            alt="The Rising Sun Judo Club Logo"
          />
        </div>
        <div className="bg-[#075AAA] flex flex-col justify-center">
          <h1 className="my-3 mx-8 uppercase md:text-3xl text-base sm:text-xl font-bold">
            Next Event
          </h1>
          <p className="mx-8 md:text-xl sm:text-lg text-sm my-4">
            <span>
              <b>Date: </b>
            </span>
            {nearestEvent?.eventDate || "No upcoming events"}
          </p>
          <p className="mx-8 md:text-xl sm:text-lg text-sm my-4">
            <span>
              <b>Event: </b>
            </span>
            {nearestEvent?.eventTitle || "TBD"}
          </p>
          <p className="mx-8 md:text-xl sm:text-lg text-sm my-4">
            <span>
              <b>Address: </b>
            </span>
            {nearestEvent?.eventAddress || "Location TBD"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default IndexContent1;
